import apiClient from './apiClient.js';

export const updateSession = async (
    session_id,
    timestamp,
    venue_id,
    admin_alert,
    active
) => {
    const session_url = '/session_update';
    try {
        const response = await apiClient.patch(session_url, {
            session_id: session_id,
            timestamp: timestamp,
            venue_id: venue_id,
            admin_alert: admin_alert,
            active: active,
        });
        return response.data;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
